<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="column" fxLayoutAlign="start center" class="nvc-profile">
  <div
    fxLayout="row"
    class="nvc-width-hundred nvc-position-sticky sc-margin-top-3"
    fxLayoutAlign="space-between center"
    [ngClass]="{ 'sc-margin-top-3': isMobileDevice() || isTabDevice() }"
  >
    <div
      fxFlex="100"
      fxLayoutAlign="center center"
      class="nvc-header-text nvc-width-hundred"
    >
      <h3>Update Profile</h3>
    </div>
  </div>
  <!-- <vc-profile-image fxFlex="100" (imageData)="assignFormData($event)" [editMode]="createMode"
          [refresh]="isReset"></vc-profile-image> -->
  <!-- <p><img src="assets/images/unit.png" alt=""></p> -->
  <div
    fxLayout="column"
    fxLayoutAlign="space-between center"
    class="ws-form-btn"
  >
    <form [formGroup]="profileForm" class="nvs-form" *ngIf="isFormData">
      <div fxLayoutAlign="center center">
        <vc-profile-image
          (imageData)="assignFormData($event)"
          *ngIf="!displayingImage"
          [editMode]="true"
          [type]="'businessuser'"
          [profileImage]="
            userData && userData.profileImageURL
              ? imagesService.getImageURL(userData.profileImageURL)
              : businessUserIcon
          "
        >
        </vc-profile-image>
        <div class="nvc-image" *ngIf="displayingImage">
          <img
            [src]="imagesService.getImageURL(displayingImage)"
            class="nvc-img"
            alt=""
          />
          <img
            src="assets/icons/cancel-red.svg"
            (click)="deleteImage()"
            class="nvc-cancel"
            alt=""
          />
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="0.5em"
        *ngIf="!isUserConsumer()"
        class="nvc-width-hundred"
      >
        <div fxFlex="49" class="nvc-input-div1">
          <mat-form-field
            hideRequiredMarker="true"
            class="sc-mat-form-input"
            appearance="outline"
          >
            <mat-label class="sc-input-label">First Name * </mat-label>
            <input
              matInput
              type="text"
              placeholder=" "
              class=""
              formControlName="firstName"
              (ngModelChange)="setDisplayName()"
            />
          </mat-form-field>
        </div>
        <div fxFlex="49" class="nvc-input-div1">
          <mat-form-field
            hideRequiredMarker="true"
            class="sc-mat-form-input"
            appearance="outline"
          >
            <mat-label class="sc-input-label">Last Name *</mat-label>
            <input
              matInput
              type="text"
              placeholder=""
              class=""
              formControlName="lastName"
              (ngModelChange)="setDisplayName()"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="nvc-input-div1 nvc-width-hundred">
        <mat-form-field
          hideRequiredMarker="true"
          class="sc-mat-form-input"
          appearance="outline"
        >
          <mat-label class="sc-input-label">Display Name *</mat-label>
          <input
            matInput
            type="text"
            placeholder=""
            class=""
            [readonly]="!isUserConsumer()"
            formControlName="displayName"
          />
        </mat-form-field>
      </div>
      <!-- Added NgClass => Disable/Gray-out the phonenumber field when it is the username  -->
      <div fxLayout="column">
        <div class="nvc-input-div1 nvc-width-hundred">
          <ngx-intl-tel-input
            [cssClass]="'iti'"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name
            ]"
            formControlName="phoneNumber"
            [selectFirstCountry]="false"
            [selectedCountryISO]="getCountryIso()"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="true"
            [numberFormat]="PhoneNumberFormat.National"
            customPlaceholder="Phone number"
          ></ngx-intl-tel-input>
          <div *ngIf="!validPhone()">
            <mat-label class="nvc-red">* Enter valid phone number </mat-label>
          </div>
        </div>
      </div>
      <!-- Added NgClass => Disable/Gray-out the email field when it is the username  -->
      <div fxLayout="column">
        <div class="nvc-input-div1 nvc-width-hundred">
          <mat-form-field
            appearance="outline"
            hideRequiredMarker="true"
            class="sc-mat-form-input"
          >
            <mat-label class="sc-input-label">Email id *</mat-label>
            <input
              matInput
              type="text"
              [readonly]="userData.email === userData.username"
              placeholder=""
              class=""
              formControlName="email"
              [ngClass]="{
                'nvc-disabled-field': userData.email === userData.username
              }"
            />
          </mat-form-field>
        </div>
        <div fxLayout>
          <div
            *ngIf="
              !validEmail() &&
              profileForm.controls['email'].dirty &&
              profileForm.controls['email'].value.length
            "
          >
            <mat-label class="nvc-red">* Enter valid email id.</mat-label>
          </div>
        </div>
      </div>
      <div
        fxLayout="column"
        *ngIf="userData.type === 'B2C' && !isUserConsumer()"
      >
        <div class="nvc-input-div nvc-width-hundred">
          <input
            type="text"
            placeholder="Company Name"
            class="nvc-input-profile"
            formControlName="companyName"
          />
        </div>
      </div>
    </form>
    <div
      fxLayout="row"
      class="nvc-input-div-buttons"
      fxLayoutAlign="space-around"
    >
      <button
        fxFlex="45"
        class="nvc-button-register nvc-width-hundred ws-cursor-pointer nvc-border-radius ws-border-none"
        type="submit"
        [disabled]="!validUserForm()"
        [ngClass]="{ 'nvc-disabled ws-no-cursor-pointer': !validUserForm() }"
        (click)="onUpdate()"
      >
        UPDATE
      </button>
      <button
        fxFlex="45"
        class="nvc-button-cancel nvc-width-hundred ws-cursor-pointer nvc-red nvc-border-radius"
        type="submit"
        *ngIf="!isMobileDevice() || dialogData?.fromSetup || dialogRef"
        (click)="closeCreation()"
      >
        CANCEL
      </button>
    </div>
    <div *ngIf="isMobileDevice()" class="nvc-margin-bottom-mobile"></div>
  </div>
</div>
